import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo13() {
    const section = 'la-puerta';
    const title = 'La Puerta';
    const description = 'Después de todo el ajetreo, llegamos a la caverna donde todo empezó.';
    const text = '<p>¡Qué locura! Me dio nostalgia, pero Tinskani me dijo que el verdadero camino estaba en el lugar más oscuro. Usé el aire de mi boca y mi energía para activar las columnas y, ¡qué crees!, se prendieron en un show de luces súper padre. De repente, apareció una puerta secreta y me di cuenta de que mi misión era usar la roca que atrapó a Camazotz como llave. Pero no era tan fácil, la puerta solo reaccionaba a mi energía y a mis emociones.</p><p>Tinskani me ayudó a recordar todo lo que había aprendido en el viaje: mi valentía, la paciencia y el poder de controlar mis sentimientos. Juntas, llenamos la roca de recuerdos bonitos, y ¡listo!, se volvió verde y se puso en la puerta solita. Pude ver a mi familia y hasta a Don Juan esperando. Me di cuenta de que yo no estaba sola y que el camino era parte de mi linaje.</p><p>Lo más padre fue que descubrí que Tinskani no es solo mi guía, ¡es mi tátara! Nos abrazamos y me despedí de ella con todo mi cariño. Al final, mi cuerpo se desintegró en un polvito verde y me convertí en una luz brillante que cruzó la puerta. ¡Ya casi estoy en casa!</p>';
    const image = '';
    const image_number = 'https://www.diadelavida.com/images/numbers/13.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 0;
    const comments_prompt = 'Valentina está a punto de llegar a casa, ¿cómo crees que será su reencuentro con su familia? ¿Qué le dirías tú si estuvieras en su lugar? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo13_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 13',
            description: 'Siempre con mi mejor amigo'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_tinskani_02.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 13',
            description: 'Una raiz de mi linaje'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}